/* eslint arrow-parens: 0 */
/* eslint implicit-arrow-linebreak: 0 */

import { defaultMemoize } from 'reselect';
import _join from 'lodash/join';
var DELIMITER = ', ';
export var getSelectedValuesText = defaultMemoize(function (values) {
  return _join(values, DELIMITER);
});